import { useTheme } from '../../hooks/useTheme';
import { useStyleSheet } from '../../hooks/useStyleSheet';
import { TypographyProps } from './Typography.types';

export const useStyles = ({ color }: Pick<TypographyProps, 'color'>) => {
  const theme = useTheme();

  // @ts-expect-error
  const textColor = theme.palette.text[color ?? ''] ?? color ?? '';

  return useStyleSheet(() => ({
    root: { color: textColor },
  }));
};
